// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nDiy","name":"styles_name__p9FUm","phone":"styles_phone__25rGP"};